<kendo-dialog-titlebar>
    {{'claims-center.claimDocumentation.attachments' | translate}}
</kendo-dialog-titlebar>

<app-show-documents-multiple [referenceType]="referenceType" [referenceId]="referenceId" [allowUpload]="true"
    [uploadFilesSettings]="uploadFilesSettings"></app-show-documents-multiple>

<kendo-dialog-actions>
    <button kendoButton (click)="cancel()" [primary]="true" submit>
        <span>{{'global.close' | translate}}</span>
    </button>
</kendo-dialog-actions>